<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import slugify from 'slugify'
  import { Link, Pencil } from 'lucide-svelte'

  let { form, sitePage = null } = $props()

  let slugEditing = $state(false)
  let slugInput = $state(null)

  export function onTitleInput() {
    if (slugEditing) return
    $form.slug = slugify($form.title, { lower: true, strict: true })
  }

  function toggleSlugEditing() {
    slugEditing = !slugEditing
    if (slugEditing) slugInput?.select()
  }
</script>

<Page.Content class="gap-6 xl:flex-row xl:items-start">

  <main class="xl:w-[66%] flex flex-col gap-6">
    <Form.Fieldset label="Details">
      <Form.Items>
        <Form.Item name="title" bind:value={$form.title} label="Title" hint="The page title" cols={12} oninput={onTitleInput} required />
      </Form.Items>
      <Form.Item name="content" label="Content" type="richtext" bind:value={$form.content} class="mt-4" />
    </Form.Fieldset>
  </main>

  <aside class="xl:w-[31%] flex flex-col gap-6">
    <Form.Fieldset label="Settings">
      <Form.Items>
        <Form.Item name="slug" bind:inputRef={slugInput} bind:value={$form.slug} label="Slug" hint="Unique identifier (e.g. terms-and-conditions)" cols={12} readonly={!slugEditing} inputClass={slugEditing ? '' : 'italic opacity-80'} required>
          {#snippet suffix()}
            <Button variant="naked" Icon={slugEditing ? Pencil : Link} onclick={toggleSlugEditing} class={slugEditing ? '' : 'opacity-60'} tabIndex={-1} />
          {/snippet}
        </Form.Item>

        <Form.Item name="show_on_signup" bind:value={$form.show_on_signup} label="Show on signup" hint="Display this page on the signup form" type="boolean" cols={12} />
      </Form.Items>
    </Form.Fieldset>
  </aside>

</Page.Content>
